var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.25a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75a.5.5 0 0 0 .5-.5v-.5a.5.5 0 1 0-1 0v.5a.5.5 0 0 0 .5.5ZM3.58 4.288a.5.5 0 1 0 .708-.707l-.354-.354a.5.5 0 1 0-.707.707l.354.354ZM2.25 7.5h-.5a.5.5 0 1 0 0 1h.5a.5.5 0 1 0 0-1ZM3.58 11.712l-.353.354a.5.5 0 1 0 .707.707l.354-.354a.5.5 0 0 0-.707-.707ZM8 13.25a.499.499 0 0 0-.5.5v.5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5ZM12.42 11.713a.5.5 0 0 0-.708.707l.354.353a.5.5 0 0 0 .707-.707l-.354-.354ZM14.25 7.5h-.5a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1ZM12.066 4.434a.499.499 0 0 0 .353-.146l.354-.354a.5.5 0 1 0-.707-.707l-.354.354a.5.5 0 0 0 .354.853Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.763591c90ef1912d787a98fc85b2326f.svg";
export { ForwardRef as ReactComponent };